import dayjs from "dayjs";
import "dayjs/locale/nl";
import relativeTime from "dayjs/plugin/relativeTime";

import { Pipe, PipeTransform } from "@angular/core";

dayjs.extend(relativeTime);

/**
 * Formats a date as a localized relative time, e.g. "5 minutes ago" or
 * "5 minuten geleden". Pass the active language so the pipe re-evaluates
 * when it changes.
 */
@Pipe({
  name: "timeago",
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date, locale: string = "en"): string {
    return dayjs(value).locale(locale).fromNow();
  }
}
